import React, { FC, ReactNode, useId } from 'react';
import { createPortal } from 'react-dom';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { useLockScroll, useOutsideClick, usePortalById } from '@shared/lib/react';
import { CrossIcon } from '@shared/assets/icons';
export interface ModalProps {
  open: boolean;
  withCloseButton?: boolean;
  onClose: () => void;
  mobile?: boolean;
  children?: ReactNode;
}
const Modal: FC<ModalProps> = ({
  open,
  withCloseButton = false,
  onClose,
  mobile = false,
  children
}) => {
  const modalContainer = usePortalById('modal-container');
  const id = useId();
  const {
    outsideClickRef
  } = useOutsideClick(onClose, id, mobile);
  useLockScroll(open);
  if (!modalContainer) return null;
  return createPortal(<ModalWrapper open={open} data-modal-id={id} className="modal">
      <ContentWrapper ref={outsideClickRef}>{open && children}</ContentWrapper>
      {withCloseButton && open && <IconWrapper onClick={onClose}>
          <CrossIcon />
        </IconWrapper>}
    </ModalWrapper>, modalContainer as Element);
};
export default Modal;
const _exp = /*#__PURE__*/() => ({
  open
}) => open ? 'block' : 'contents';
const _exp2 = /*#__PURE__*/() => ({
  open
}) => open ? 1 : 0;
const _exp3 = /*#__PURE__*/() => ({
  open
}) => open ? 1 : -1;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.overlay.primary;
const ModalWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ModalWrapper",
  class: "m1vnx7sb",
  propsAsIs: false,
  vars: {
    "m1vnx7sb-0": [_exp()],
    "m1vnx7sb-1": [_exp2()],
    "m1vnx7sb-2": [_exp3()],
    "m1vnx7sb-3": [_exp4()]
  }
}));
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const ContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c16rw7zg",
  propsAsIs: false,
  vars: {
    "c16rw7zg-0": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.primary;
const IconWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconWrapper",
  class: "i1jbx3hz",
  propsAsIs: false,
  vars: {
    "i1jbx3hz-0": [_exp6()]
  }
}));

require("./Modal.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Modal.tsx");